import React from 'react';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

export default function FullCalendarPrem() {
  const events = [
    // {
    //   academicPlannerId: null,
    //   allDay: false,
    //   backgroundColor: 'grey',
    //   editable: true,
    //   end: '2022-06-29 15:00:00',
    //   facilityBookingNumber: '87123490',
    //   facilityCampus: null,
    //   facilityCapacity: '50',
    //   facilityName: 'SPJ-Mumbai-CR04',
    //   facilityType: 'Classroom',
    //   id: 'a1o6D000000rZLwQAM',
    //   start: '2022-06-29 12:00:00',
    //   title: 'Exam',
    // },
    {
      title: 'lecture',
      start: '2022-06-29 12:00:00',
      end: '2022-06-29 15:00:00',
    },
    {
      title: 'lecture',
      start: '2022-06-29 10:00:00',
      end: '2022-06-29 12:00:00',
      resourceId: 'A',
    },
  ];

  const resources = [
    {
      id: 'A',
      groupId: '1',
      title: 'Resource A',
    },
    {
      id: 'B',
      groupdId: '1',
      title: 'Resource B',
    },
    {
      id: 'C',
      groupId: '2',
      title: 'Resource C',
    },
  ];
  return (
    <div>
      Full calendar Prem
      <FullCalendar
        schedulerLicenseKey="0470008209-fcs-1655977369"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        }}
        plugins={[resourceTimelinePlugin]}
        events={events}
        resources={resources}
        initialView="resourceTimeline"
      />
    </div>
  );
}
